module.exports = __webpack_public_path__ + "assets/img/field.119802d1.svg";